import { FlatTheme } from './FlatTheme';
import type { TileTheme } from './TileTheme';

/**
 * Registry der verfuegbaren Render-Themes. Ein spaeteres Pixel-Art-Theme
 * wird hier mit einer Zeile registriert; die Map waehlt per `theme`-Feld.
 */
const factories: Record<string, () => TileTheme> = {
  flat: () => new FlatTheme(),
};

export function createTheme(name: string): TileTheme {
  const factory = factories[name] ?? factories['flat']!;
  return factory();
}
